/**
 * We use the centered month as number "2" for the following months: [1, 2, 3]
 * whereas calendar-day-picker uses the "1" as the default month.
 * This function returns the correct month to display
 * @param date
 * @param numberOfMonths
 * @returns
 */
import { getHints } from '~/utils/client-hints';

export const WIDTH_FOR_3_MONTHS = 1100;

export const getDefaultMonth = (centeredMonth: Date, numberOfMonths: number) => {
	const defaultMonth = new Date(centeredMonth.getTime());

	if (numberOfMonths === 3) {
		defaultMonth.setMonth(defaultMonth.getMonth() - 1);
	}

	return defaultMonth;
};

/**
 * We use the centered month as number "2" for the following months: [1, 2, 3]
 * whereas calendar-day-picker uses the "1" as the default month.
 * This function returns the correct month to display
 * @param date
 * @param numberOfMonths
 * @returns
 */
export const getCenteredMonth = (defaultMonth: Date, numberOfMonths = 3) => {
	const centeredMonth = new Date(defaultMonth.getTime());
	if (numberOfMonths === 3) {
		centeredMonth.setMonth(defaultMonth.getMonth() + 1);
		return centeredMonth;
	}
	return centeredMonth;
};

/**
 *  number of months to display, based on client hint for screen size
 * @param request
 * @returns
 */
export const getNumberOfMonthsToDisplay = (request: Request) => {
	const width = getHints(request).width;
	// number of months to display, based on client hint for screen size
	return width >= WIDTH_FOR_3_MONTHS ? 3 : 1;
};

/**
 * Retrieves the current period, by a startDate and endDate (1 month prior to 1 month after)
 * @returns
 */
export const getMonthPeriod = (month?: Date, offset = 2) => {
	if (!month) {
		month = new Date();
	}

	// Calculate the start date as the first day of the month prior to 'center'
	const startDate = new Date(month.getFullYear(), month.getMonth() - 1 - offset, 1);

	// Calculate the end date as the last day of the month after 'center'
	// To get the last day of the month, go to the first day of the next month and subtract one day
	const endDate = new Date(month.getFullYear(), month.getMonth() + 1 + offset, 0);

	return {
		endDate,
		startDate,
	};
};

/**
 *  Returns the month from an epoch (in seconds)
 *
 */
export const getMonthFromEpoch = (epoch: string | null) => {
	if (!epoch) {
		return null;
	}

	const month = parseInt(epoch, 10) * 1000;
	return new Date(month);
};
